
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.65 5.04A1.5 1.5 0 009.5 4.5H7.22l.28-.715A2.065 2.065 0 005.555 1a.5.5 0 00-.455.295L3.675 4.5H2.5A1.5 1.5 0 001 6v3.5A1.5 1.5 0 002.5 11h6.365a1.5 1.5 0 001.475-1.23l.635-3.5a1.5 1.5 0 00-.325-1.23zM3.5 10h-1a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h1V10zM10 6.09l-.635 3.5a.5.5 0 01-.5.41H4.5V5.105l1.36-3.06a1.055 1.055 0 01.69 1.39l-.265.715A1 1 0 007.22 5.5H9.5a.5.5 0 01.385.18.5.5 0 01.115.41z","fill":"#797B86"}})])
          )
        }
      }
    